// Import locales
import 'dayjs/locale/en'; // English (United States)
import 'dayjs/locale/en-gb'; // English (United Kingdom)
import 'dayjs/locale/en-ca'; // English (Canada)
import 'dayjs/locale/en-au'; // English (Australia)
import 'dayjs/locale/en-nz'; // English (New Zealand)
import 'dayjs/locale/cs'; // Czech (Czech Republic)
import 'dayjs/locale/sk'; // Slovak (Slovakia)
import 'dayjs/locale/de'; // German (Germany)
import 'dayjs/locale/nl'; // Dutch (Netherlands)

import dayjs, { Dayjs } from 'dayjs';

export const getFormatDate = (value: Dayjs | null, dateFormat: string) => {
  if (!value) return null;

  return dayjs(value).format(dateFormat);
};

export const formatTimestamp = (timestamp: string): string => {
  return dayjs(timestamp).format('MM-DD-YYYY HH:mm:ss');
};
